export const table_theme_configuration = {
  root: {},
  colorScheme: {
    light: {
      headerCell: {
        background: "#FCFCFD",
        color: "#000",
      },
      columnTitle: {
        fontWeight: "400",
      },
      row: {
        stripedBackground: "#F6F7F9",
        Background: "#FFFFFF",
        hoverBackground: "#F0F5FF",
        color: "#6b6b6c",
      },
      rowhover: {
        color: "#F0F5FF",
      },
      sortrow: {
        color: "#FCFCFD",
      },
      tableinput: {
        color: "#D9D9D9",
      },
    },
    dark: {
      headerCell: {
        background: "#212630",
        color: "#fff",
        hoverBackground: "#112545",
      },
      columnTitle: {
        color: "#65A9F3",
      },
      row: {
        stripedBackground: "#151827",
        Background: "#010622",
        hoverBackground: "#112545",
        color: "#adaeb3",
      },
      rowhover: {
        color: "#112545",
      },
      sortrow: {
        color: "#212630",
      },
      tableinput: {
        color: "#424242",
      },
    },
  },
};
